import { pathToTreeKeys } from '../../../../../utils/applyMenuConfigChanges/deleteMembers';
import { getMemberFromType, isPrimitiveType, memberIsNotEmpty } from '../utils';
import { PARAM_TYPES } from '../../../../../utils/treeVisitors/markCallbacksVisitor/types';
import { extractType } from '../../utils';
import { extractFirstLevelOfTypeObject, isLegacyType } from '../../typeParser';
import { isObject } from '../../../../../utils/typeUtils';

const isOperation = (currentNode, key) => {
  if (currentNode.data) {
    const keyWithoutLeadingSlash = key.substring(1);
    return (
      currentNode.data &&
      currentNode.data.operations.some(
        (operation) => operation.name === keyWithoutLeadingSlash
      )
    );
  }
  return false;
};

export const isTreeNodeOrOperation = (tree, type) => {
  if (Array.isArray(type)) {
    return false;
  }
  if (isLegacyType(type) && isObject(type)) {
    return isTreeNodeOrOperation(tree, extractType(type));
  }
  const keys = pathToTreeKeys(type);
  let currentNode = tree;
  for (const key of keys) {
    if (!currentNode[key]) {
      return isOperation(currentNode, key);
    }
    currentNode = currentNode[key];
  }
  return true;
};

export const isLink = (tree, type = '') => {
  if (Array.isArray(type)) {
    return true;
  }
  return isTreeNodeOrOperation(tree, extractType(type));
};

const isCallback = (metaData) => metaData.type === PARAM_TYPES.FUNCTION;

export const shouldAbleExpand = (tree, type, paramMetaData = {}, store) => {
  if (Array.isArray(type)) {
    return type.some((possibleType) =>
      shouldAbleExpand(tree, possibleType, paramMetaData, store)
    );
  }

  if (isLegacyType(type)) {
    return (
      !isPrimitiveType(type, store) &&
      !isCallback(paramMetaData) &&
      type !== 'struct' &&
      !isLink(tree, type) &&
      memberIsNotEmpty(getMemberFromType(type, store))
    );
  }

  if (type.complexType) {
    const shouldGenericTypeBeExpanded =
      type.complexType.referenceType &&
      shouldAbleExpand(
        tree,
        type.complexType.referenceType,
        paramMetaData,
        store
      );
    const shouldSomeTypeParamsBeExpanded = type.complexType.typeParams.some(
      (typeParam) => shouldAbleExpand(tree, typeParam, paramMetaData, store)
    );
    return (
      !isCallback(paramMetaData) &&
      (shouldGenericTypeBeExpanded || shouldSomeTypeParamsBeExpanded)
    );
  }

  if (type.referenceType) {
    return (
      !isCallback(paramMetaData) &&
      shouldAbleExpand(
        tree,
        extractFirstLevelOfTypeObject(type),
        paramMetaData,
        store
      )
    );
  }

  if (type.unionType) {
    return (
      !isCallback(paramMetaData) &&
      shouldAbleExpand(tree, type.unionType.type, paramMetaData, store)
    );
  }

  return false;
};
